import * as Sentry from '@sentry/react'

let sentryInitialized = false

export function initSentry() {
  if (sentryInitialized) {
    return
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    if (import.meta.env.PROD) {
      console.warn('Sentry DSN not configured in production (VITE_SENTRY_DSN)')
    }
    return
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
    replaysSessionSampleRate: import.meta.env.PROD ? 0.01 : 0,
    replaysOnErrorSampleRate: 1,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      if (import.meta.env.DEV) {
        console.debug('Sentry event (dev, dropped):', event)
        return null
      }
      return event
    },
  })

  sentryInitialized = true
}

export function captureException(error: Error, context?: Record<string, any>) {
  Sentry.captureException(error, context)
}

export function captureMessage(message: string, level?: Sentry.SeverityLevel) {
  Sentry.captureMessage(message, level)
}

export default Sentry
